<template>
  <div id="app">
    <global-header></global-header>
    <router-view/>
    <global-footer></global-footer>
  </div>
</template>

<script>
import GlobalHeader from './components/common/Header'
import GlobalFooter from './components/common/Footer'
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'app',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  methods: {
    
  },
  data () {
    return {
      languageName: this.$store.state.languageName
    }
  },  
  beforeCreate: function() {
      document.body.className = this.$store.state.languageName;
  }  
}
</script>

<style lang="scss">
  @import "./styles/style";
</style>


// WEBPACK FOOTER //
// src/App.vue